import axios from 'axios';
import { helperGetApiHeaders } from 'helpers/ApiHelper';
import { getEmailSubmissionBody, getEmailSubmissionUrl } from './EmailSubmissionFormHelpers';

export const SEND_EMAIL = 'SEND_EMAIL';

export function sendEmail({ email, accessToken, deviceId }) {
  const pathKey = 'emailCapture';
  const url = getEmailSubmissionUrl(pathKey);
  const body = getEmailSubmissionBody(email);
  const headers = helperGetApiHeaders({ pathKey, accessToken, deviceId });
  const request = axios.post(url, body, headers);

  return {
    type: SEND_EMAIL,
    payload: request,
  };
}
